var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheSnapshotBundleList',{attrs:{"bundleType":_vm.distributionReasons.MATERIAL_SHARING}})
}
var staticRenderFns = []

export { render, staticRenderFns }